export default function Footer() {
  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-bg-secondary)] px-6 py-4 mt-auto">
      <p className="text-xs text-[var(--color-text-tertiary)] leading-relaxed max-w-4xl">
        <span className="font-medium">Disclaimer:</span> This site provides technical reference
        materials organized based on publicly available SEMI standards. Content may be updated as
        standards evolve. For authoritative specifications, please refer to official SEMI documentation.
      </p>
    </footer>
  );
}
